import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiTrendingUp } from 'react-icons/fi';
import { API_BASE_URL as API_BASE } from '../services/api';

const HotOffers = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/hot-offers/`)
      .then(r => r.json())
      .then(data => {
        const list = Array.isArray(data) ? data : (data.results || []);
        setOffers(list);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (offers.length === 0) return null;

  return (
    <section className="hot-offers-section section-container" ref={ref} id="hot-offers" style={{ padding: '60px 0' }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        style={{ textAlign: 'center', marginBottom: 36 }}
      >
        <span className="section-tag" style={{ background: 'linear-gradient(90deg, #ff5c5c, #ff8c42)', color: 'white', padding: '6px 14px', borderRadius: 20, fontSize: 13, fontWeight: 600 }}>
          🔥 Hot Offers
        </span>
        <h2 className="section-title" style={{ marginTop: 16 }}>
          Qaynoq <span className="gold-text">takliflar</span>
        </h2>
        <p className="section-desc" style={{ maxWidth: 520, margin: '12px auto 0' }}>
          Eng yaxshi narxlar va cheklangan vaqtli aksiyalar — shoshiling!
        </p>
      </motion.div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
        {offers.slice(0, 6).map((o, i) => (
          <motion.a
            key={o.id}
            href={o.cta_url || '#'}
            target={o.cta_url ? '_blank' : undefined}
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            style={{
              position: 'relative',
              minHeight: 220,
              borderRadius: 18,
              overflow: 'hidden',
              display: 'block',
              textDecoration: 'none',
              boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
            }}
          >
            {o.image && <img src={o.image} alt={o.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />}
            <div style={{
              position: 'absolute', inset: 0,
              background: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.8) 100%)',
            }} />
            <div style={{ position: 'relative', height: '100%', padding: 18, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', zIndex: 1 }}>
              {o.is_featured ? (
                <span style={{ display: 'inline-block', background: '#D4AF37', color: '#0d1137', padding: '4px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700, alignSelf: 'flex-start' }}>
                  ⭐ Featured
                </span>
              ) : (
                <span style={{ display: 'inline-block', background: '#ff5c5c', color: 'white', padding: '4px 10px', borderRadius: 6, fontSize: 11, fontWeight: 700, alignSelf: 'flex-start' }}>
                  <FiTrendingUp style={{ marginRight: 4, verticalAlign: 'middle' }} />HOT
                </span>
              )}
              <div>
                <h3 style={{ color: 'white', fontSize: 20, fontWeight: 700, marginBottom: 6 }}>{o.title}</h3>
                {o.subtitle && <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, marginBottom: 10 }}>{o.subtitle}</p>}
                <span style={{ display: 'inline-block', background: '#D4AF37', color: '#0d1137', padding: '8px 14px', borderRadius: 8, fontWeight: 600, fontSize: 13 }}>
                  {o.cta_text || 'Batafsil'} →
                </span>
              </div>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default HotOffers;
